import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import { Tabs } from "antd";
import "../Inventory/Inventory.css";
import InventoriesDetails from "./Inventories/InventoriesDetails";
import Products from "./Products/Products";
import { OverallCountSheet } from "./CountSheet/OverallCountSheet";
//import Template from './Template'
// import MasterTemplate from "./MasterTemplates/MasterTemplate";
import Settings from "./Settings";
import InventorySummary from "./InventorySummary/InventorySummary";
import { useLocation } from "react-router-dom";
import Reconciliation from "../BillPay/Reconciliation";
import Invoices from "../BillPay/Invoices";
import Payments from "../BillPay/Payments";
import Setup from "../BillPay/Setup";

function Inventory() {
  const [activeKey, setActiveKey] = useState('4');
  const { pathname } = useLocation();

  const onChange = (key) => {
    setActiveKey(key);
  };

  const items = [
    {
      key: "4",
      label: "Inventory Summary",
      children: <InventorySummary setActiveKey={setActiveKey} />,
    },
    {
      key: "1",
      label: "Inventories",
      children: <InventoriesDetails />,
    },
    {
      key: "2",
      label: "Count Sheet",
      children: <OverallCountSheet />,
    },
    {
      key: "3",
      label: "Products",
      children: <Products />,
    },
    // {
    //   key: '4',
    //   label: 'Settings',
    //   children: <Settings />
    // }
  ];

  const billPayItems = [
    {
      key: "1",
      label: "Reconciliation",
      children: <Reconciliation />,
    },
    {
      key: "2",
      label: "Invoices",
      children: <Invoices />,
    },
    {
      key: "3",
      label: "Payments",
      children: <Payments />,
    },
    {
      key: "4",
      label: "Setup",
      children: <Setup />,
    },
  ];

  return (
    <>
      {/* <Header /> */}
      <div className="startinventory">
        {!pathname.includes('bill_pay')
          ? (
            <Tabs
              destroyInactiveTabPane={true}
              defaultActiveKey="4"
              items={items}
              onChange={onChange}
              activeKey={activeKey}
            />
          )
          : (
            <Tabs
              destroyInactiveTabPane={true}
              defaultActiveKey="1"
              items={billPayItems}
              onChange={onChange}
            />
          )
        }
      </div>
    </>
  );
}
export default Inventory;
